const debugMode = false;

export function log(...args) {
  if (debugMode) {
  }
}

export function getBaseLog(x, y) {
  return Math.log(y) / Math.log(x);
}

export function dbFromFloat(floatVal) {
  return getBaseLog(10, floatVal) * 20;
}

export function findAudioProcBufferSize(numSamplesIn) {
  return [256, 512, 1024, 2048, 4096, 8192, 16384].reduce((a, b) => (
    Math.abs(b - numSamplesIn) < Math.abs(a - numSamplesIn) ? b : a));
}
